module.exports = __webpack_public_path__ + "img/209-Blanc cérusé.png";